module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-ni.8e3f9e90.png";